import type { FC } from "react";
import { useMemo } from "react";
import type { CSSProperties } from "styled-components";
import styled, { useTheme } from "styled-components";

import { WorkspaceIconContainer } from "@/components/MondayBasics/MondayWorkspaceIcon/WorkspaceIconContainer";
import BoardLabelOverflow from "@/components/QuickSearch/components/BoardDropdown/components/BoardLabelOverflow";
import type { BoardDropdownOption } from "@/components/QuickSearch/components/BoardDropdown/models/boardDropdownOption";
import { getThemeTokenValue } from "@/design/themes/Themes";
import themeGet, { get } from "@/utils/theme-gets";

type BoardValueProps = BoardDropdownOption & { style?: CSSProperties };

export const BoardValue: FC<BoardValueProps> = ({ label, workspace, style }) => {
  const { id: workspaceId, name: workspaceName, ...workspaceMapped } = workspace;

  const theme = useTheme();
  const workspaceIconSize = useMemo(
    () => parseFloat(getThemeTokenValue(get(theme, "size.s", null))),
    [get(theme, "size.s", null)]
  );
  return (
    <BoardValueWrapper style={style}>
      <BoardLabel>
        <BoardLabelOverflow tooltip={label}>
          <BoardName>{label}</BoardName>
        </BoardLabelOverflow>
      </BoardLabel>
      <WorkspaceIconContainer
        workspaceId={workspaceId}
        workspaceName={workspaceName}
        size={workspaceIconSize}
        {...workspaceMapped}
      ></WorkspaceIconContainer>
    </BoardValueWrapper>
  );
};

const BoardValueWrapper = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: ${themeGet("spacing.s")};
  padding: ${themeGet("spacing.s")} ${themeGet("spacing.m")};
`;

const BoardName = styled.span`
  font: ${themeGet("typography.body.bolder.s")};
`;

const BoardLabel = styled.div`
  display: flex;
  align-items: center;
  gap: ${themeGet("spacing.s")};
  overflow: hidden;
`;
